import { normalizeArtifactRef } from 'flare-chat-core/contracts/context/artifact-ref';

/** Explicit Markdown replacement only. Catalog owns admission, identity and revision. */
export const buildCanvasDraftSaveAppendPayload = ({ artifactRef, requestId, sessionId, draftText } = {}) => {
  const expectedBase = normalizeArtifactRef(artifactRef);
  if (!requestId || !sessionId || typeof draftText !== 'string') {
    throw new TypeError('An edit request identity, session and Markdown content are required');
  }
  return { expected_base: expectedBase, request_id: requestId, session_id: sessionId, content: draftText };
};
export default buildCanvasDraftSaveAppendPayload;
